<template lang="pug">
	.upload-amazon-s3-multiple(v-if="showed")
		.modal(:tabindex="-1" :role="'dialog'" :style="{'display': 'block'}")
			.modal-dialog.modal-dialog-centered(:role ="'document'")
				.modal-content
					.modal-header
						h5.modal-title Upload Amazon S3 Multiple
					.modal-body
						.modal-loaded
							.form-group
								.project-wrapper(v-for="project in projects")
									.project-title {{project.title}}
									.status-wrapper
										.project-folders(v-if="!projectsData[project.id].status")
											input.form-control(:value="projectsData[project.id].templateFolder" v-on:change="updateFolderValue('templateFolder', project.id, $event.target.value)")
											span /
											input.form-control(:value="projectsData[project.id].projectFolder" v-on:change="updateFolderValue('projectFolder', project.id, $event.target.value)")
											label.col-form-label Save folders
											label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
												input.switch-input.form-check-input(type="checkbox" checked="projectsData[project.id].saveFolders" @change="switchSaveFolders(project.id)")
												span.switch-slider(data-checked="On" data-unchecked="Off")
												span.switch-handle
										.project-uploading(v-else-if="projectsData[project.id].status === 'uploading'")
											.icon.fa.fa-spinner.fa-spin
										.project-uploaded(v-else-if="projectsData[project.id].status === 'result'")
											i.fa.fa-check
											span Successfully uploaded!
											button.btn.btn-dark(type="button" v-on:click="showTag(projectsData[project.id].resultTag)" v-b-tooltip.hover.right="{delay: { show: 100, hide: 100 }, title: 'View script tag text'}")
												i.fa.fa-file-code-o
										.project-error(v-else)
											i.fa.fa-exclamation
											span {{projectsData[project.id].error}}
					.modal-footer
						button.btn.btn-primary(type="button" :class="{'disabled': currentState === 'uploading'}" v-on:click="upload") Upload
						button.btn.btn-dark(type="button" v-on:click="close") Close

</template>
<script>
	import Screen 				from './../../mixins/screen';
	import {Project} from "@/services/Project";
	import {Server} from "@/services/Server";

	export default {
		name: 'UploadAmazonS3Multiple',
		mixins: [Screen],
		screen: {
			events: {
				"Multiple Upload Progress": function (data) {
					if (data.UploadProgress === 'uploading') {
						this.projectsData[data.UploadProjectId].status = 'uploading';
					}
					else if (data.UploadProgress === 'result') {
						this.projectsData[data.UploadProjectId].status = 'result';
						this.projectsData[data.UploadProjectId].resultTag = data.UploadResult.data;
					}
					else if (data.UploadProgress === 'error') {
						this.projectsData[data.UploadProjectId].status = 'error';
						this.projectsData[data.UploadProjectId].error = data.error;
					}
				}
			},
			updateOn: [],
			showed: false,
		},
		data() {
			return {
				currentState: 'editing',
			}
		},
		methods: {
			collectData(action, projectIds) {
				if (!projectIds) {
					return
				}
				projectIds = Array.from(projectIds);
				this.projects = {};
				this.projectsData = {};

				projectIds.forEach(id => {
					let project = _.clone(Project.Projects[id]);
					this.projects[id] = project;
					this.projectsData[id] = {
						projectId: id,
						templateFolder: project.AdditionalData.templateFolder || (Template.SelectedTemplate ? Template.SelectedTemplate.codename : ''),
						projectFolder: project.AdditionalData.projectFolder || project.id,
						saveFolders: true
					}
				});

				this.currentState = 'editing';
			},
			close() {
				this.hide();
			},
			switchSaveFolders(projectId) {
				this.projectsData[projectId].saveFolders = !this.projectsData[projectId].saveFolders;
			},
			updateFolderValue(property, projectId, value) {
				this.projectsData[projectId][property] = value;
			},
			upload() {
				if (this.currentState === 'uploading') return;

				Server.sendToSocket({
					UploadMultipleCreatives: {
						projectsData: this.projectsData,
						params: {
							debug: false,
							moat: false,
							basis: false,
							basisVars: '',
							htmlMacros: false,
							htmlMacrosVars: '',
							releaseType: 'js-minified',
							region: Server.Config['amazon-s3-bucket-region'] || 'eu-central-1'
						}
					}
				});

				this.currentState = 'uploading';
			},

			showTag(tagText) {
				Broadcast.call("Show Display Text", [tagText]);
			}
		}

	}
</script>
<style lang="sass">

	.upload-amazon-s3-multiple
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.modal-dialog.modal-dialog-centered
			max-width: 800px
			max-height: 80%

		.modal-content
			border: none
			background: none

			.modal-header
				background-color: #343b41
				border-bottom: 1px solid #23282c
				color: #e4e7ea

			.modal-body
				background-color: #3a4149
				padding: 1rem 1rem 0 1rem

				.modal-loading
					display: flex
					width: 100%
					align-items: center
					flex-direction: column
					justify-content: center

					.fa-spin
						font-size: 50px
						color: #e4e7ea

				.modal-loaded

					.form-group
						padding: 5px
						border: 1px solid
						border-radius: 5px
						max-height: 50vh
						overflow-x: hidden
						overflow-y: auto

					::-webkit-scrollbar
						width: 10px
						margin-left: -10px
						-webkit-appearance: none
						appearance: none

					::-webkit-scrollbar-thumb
						height: 50px
						background-color: rgba(255,255,255,0.2)
						background-clip: content-box
						border-color: transparent
						border-style: solid
						border-width: 1px 2px
						border-radius: 5px

					.project-wrapper
						color: white
						padding: 5px
						border-radius: 5px

						&:nth-of-type(odd)
							background-color: #00000030

							.project-uploaded
								>button
									background-color: #3a4149


					.status-wrapper
						display: flex
						height: 35px
						align-items: center

						i
							font-size: 25px



						>.project-uploaded
							display: flex
							justify-content: flex-start
							align-items: center
							width: 80%
							gap: 15px

							.fa-check
								color: #83e183

							span
								display: flex

							button
								display: flex
							i
								display: flex

						>.project-error
							display: flex
							justify-content: flex-start
							align-items: center
							width: 80%
							gap: 15px

							.fa-exclamation
								color: red

							span
								display: flex

							button
								display: flex
							i
								display: flex

					.project-folders
						width: 100%
						display: flex
						flex-direction: row
						justify-content: space-between
						align-items: center

						.form-control
							color: #e4e7ea
							background-color: #515b65
							border: 1px solid #23282c

						input
							width: 300px

						.switch-slider
							background-color: #3a4149
							//border-color: #3a9d5d

						.switch-success .switch-input:checked+.switch-slider
							background-color: #4dbd74
							border-color: #3a9d5d

					textarea
						background-color: #515b65
						color: #c8ced3
						border-color: #c8ced3

			.modal-footer
				background-color: #3a4149
				border: none
				justify-content: space-between
				padding: 5px 1rem 1rem 1rem

				button.disabled
					//pointer-events: none
					cursor: not-allowed


</style>
